import { EnvironmentCardContainer } from '../../containers/environment-card-container/EnvironmentCardContainer'
import type { Application } from '../../store/radix-api'
import { Banner } from '../banner/Banner'
import { NewApplyConfigPipelineLink } from '../link/apply-config-pipeline-link'
import { RadixConfigFileLink } from '../link/radix-config-file-link'
import styles from './environmentCardList.module.css'

interface EnvironmentCardListProps {
  readonly application: Pick<Application, 'name' | 'registration' | 'environments'>
}

export const EnvironmentCardList = (props: EnvironmentCardListProps) => {
  const { application } = props
  const hasEnvironments = application.environments && application.environments.length > 0

  return (
    <>
      {hasEnvironments ? (
        <ul className={styles.environmentCardList}>
          {application?.environments?.map((environment) => (
            <li key={environment.name}>
              <EnvironmentCardContainer application={application} environment={environment} />
            </li>
          ))}
        </ul>
      ) : (
        <Banner>
          <Banner.Message>
            The <RadixConfigFileLink registration={application.registration} /> file must be read by Radix in order to
            show information about environments.
            <br />
            Run the <NewApplyConfigPipelineLink appName={application.name}>apply-config</NewApplyConfigPipelineLink>{' '}
            pipeline job to read the file from the application's GitHub repository.
          </Banner.Message>
        </Banner>
      )}
    </>
  )
}
